<template>
  <el-dialog
    title="选择人员"
    width="70%"
    top="2vh"
    :close-on-click-modal="false"
    :before-close="close"
    :visible.sync="config.dialogVisible"
    :append-to-body="true"
  >
    <el-container>
      <el-main class="table-main">
        <el-form
          :model="form"
          label-width="80px"
          size="mini"
          class="table-form"
        >
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item :label="$t('base.info.user.Name')">
                <el-input v-model="form.nameCn"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="18" style="display: flex;justify-content: end;">
              <el-button
                icon="el-icon-search"
                align="center"
                @click="search('refresh')"
                size="small"
                >{{ $t("common.Search") }}</el-button
              >
              <el-button
                icon="el-icon-refresh-left"
                @click="reset"
                align="center"
                size="small"
                >刷新</el-button
              >
            </el-col>
          </el-row>
        </el-form>
        <el-table
          :data="userRadioListData"
          ref="userRadioList"
          border
          highlight-current-row
          stripe
          @selection-change="curChange"
          @row-click="curRow"
        >
          <el-table-column type="selection" width="60" align="center"></el-table-column>
          <el-table-column prop="deptName" label="组织部门"></el-table-column>
          <el-table-column prop="userCode" label="编号" width="70px"></el-table-column>
          <el-table-column prop="nameCn" label="姓名" min-width="150px"></el-table-column>
          <el-table-column prop="telephone" label="手机" width="100px"></el-table-column>
          <el-table-column prop="currentPosition" label="岗位"></el-table-column>
        </el-table>
      </el-main>
      <el-footer class="table-footer dialog clearfix">
        <el-col :span="24">
          <table-page
            ref="userRadioListPage"
            :url="userRadioListUrl"
            :form="form"
            :urlDafault="true"
            @page-change="convert"
          ></table-page>
        </el-col>
        <el-col :span="24" style="display: flex;justify-content: end;">
          <el-button type="primary" size="mini" @click="confirm">{{
            $t("common.Ok")
          }}</el-button>
          <el-button size="mini" @click="close">{{
            $t("common.Cancel")
          }}</el-button>
        </el-col>
      </el-footer>
    </el-container>
  </el-dialog>
</template>

<script>
import TablePage from "@/components/TablePage";

import moment from "moment";
export default {
  props: {
    config: {},
    
  },
  data() {
    return {
      form: {
        status: 50
      },
      //科室弹框
      deptConfig: {
        dialogVisible: false,
      },
      userRadioListUrl: this.global.BASE_INFO + "/user/findUserBaseInfo",
      userRadioListData: [],
      multipleSelection: [],
      nodeData: {
        deptCode: "",
        deptName: "",
        deptId: ""
      },
      defaultProps: {
        children: "children",
        label: "deptName",
        id: "deptId",
      },
      dialogFormVisible: false,
      tree: [],
    };
  },
  components: {
    TablePage,
  },
  created(){
    this.gettreeData()
  },
  methods: {
    curRow(row, column){
      this.$refs.userRadioList.toggleRowSelection(row);
    },
    gettreeData() {
      let asp = JSON.parse(localStorage.getItem("user")).asp;
      this.$axios
        .post(`${this.global.BASE_INFO}/dept/findAllBaseDeptTree`, {
          asp,data: {  categoryCode:'dept'},
        })
        .then((res) => {
          if (res.data.status === "Y") {
            this.tree = res.data.data;
          }
        });
    },
    deptComfirm(){
      this.form.deptCode = this.nodeData.deptCode;
      this.form.deptName = this.nodeData.deptName;
      this.form.deptId = this.nodeData.deptId;
      this.dialogFormVisible = false;
    },
    openTree() {
      this.deptConfig.dialogVisible = true;
    },
    deptConfirm(val) {
      this.$set(this.form, "deptName", val.name);
      this.$set(this.form, "deptId", val.id);
    },
    handleNodeClick(data) {
      this.nodeData.deptCode = data.deptCode;
      this.nodeData.deptName = data.deptName;
      this.nodeData.deptId = data.deptId;
    },
    close() {
      this.config.dialogVisible = false;
      this.$refs["userRadioList"].clearSelection();
      this.$emit("update:userConfig", this.config);
    },
    confirm() {
      if (this.multipleSelection.length) {
        this.$emit("confirm", this.multipleSelection);
        
        this.close();
      } else {
        this.$message("请选择用户");
      }
    },
    search(param) {
      this.$refs["userRadioListPage"].getTableData(param);
    },
    reset() {
      this.form = {
        status: 50
      };
      this.$refs["userRadioList"].clearSelection();
      this.multipleSelection = [];
      this.$nextTick(() => {
        this.search('refresh');
      });
    },
    convert(tableData) {
      this.userRadioListData = tableData.data;
    },
    getCurrentRow(selection) {
      this.multipleSelection = selection;
    },
    curChange(currentRow, oldCurrentRow) {
      this.multipleSelection = currentRow;
    },
    dateFormat(date) {
      if (date) {
        return moment(date).format("YYYY-MM-DD");
      }
      return "";
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/UserSelect.vue